export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail nebo uživatelské jméno',
      invalidEmailOrUsername: 'Nesprávný e-mail nebo uživatelské jméno',
      invalidPassword: 'Nesprávné heslo',
      logInToPlanka: 'Přihlásit se do Planka',
      noInternetConnection: 'Bez připojení k internetu',
      pageNotFound_title: 'Stránka nenalezena',
      password: 'Heslo',
      projectManagement: 'Správa projektu',
      serverConnectionFailed: 'Připojení k serveru selhalo',
      unknownError: 'Neznámá chyba, zkuste to později',
    },

    action: {
      logIn: 'Přihlásit se',
    },
  },
};
